var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2942 3.34589C11.2236 3.49041 9.86423 4.61186 9.55615 6.4298C9.51103 6.69604 9.50708 6.83956 9.50708 8.21456V9.59637H8.42017H7.33325V11.0813V12.5661L8.41675 12.5696L9.50024 12.5731L9.50359 16.6347L9.50694 20.6963H11.0827H12.6584L12.6619 16.6313L12.6653 12.5663H14.1955H15.7256L15.7334 12.4815C15.7436 12.3709 15.8649 9.77607 15.8647 9.67435L15.8645 9.59637H14.2639H12.6634L12.6694 8.37246C12.6745 7.33476 12.6787 7.12999 12.6971 7.0265C12.7728 6.60025 12.9496 6.38986 13.322 6.28284C13.5268 6.22401 13.6234 6.21968 14.7317 6.21964L15.7795 6.2196L15.7877 6.08738C15.7996 5.89436 15.8572 3.45491 15.8501 3.44784C15.8429 3.4408 15.3019 3.39151 15.0168 3.37191C14.4686 3.33422 13.6405 3.32172 13.2942 3.34589Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.296ce7dc0c8fcd329995be0822ecd341.svg";
export { ForwardRef as ReactComponent };